import { Box, Heading } from "@primer/react";
import { colors } from "../theme/tokens";

interface ISectionTitleProps {
    title: string;
    /** Action zone bên phải (button, dropdown filter, count...). */
    actions?: React.ReactNode;
    mb?: number;
}

/**
 * Tiêu đề section với background `#c3dcff` đặc trưng (theo project Old).
 * Dùng cho table titles, panel headers — tách rõ blocks trong 1 page.
 *
 *   ┌─[ Title pill xanh nhạt ]──────────── [actions]
 *   │
 *   └─ underline 1px gray
 */
const SectionTitle = ({ title, actions, mb = 3 }: ISectionTitleProps) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "space-between",
                gap: 2,
                mb,
                borderBottom: "1px solid",
                borderColor: "border.muted",
                position: "relative",
                zIndex: 2,
            }}
        >
            <Heading
                as="h2"
                sx={{
                    fontSize: 2,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    py: "7px",
                    pl: 3,
                    pr: 4,
                    bg: colors.primarySubtle,
                    color: colors.text,
                    borderTopLeftRadius: 2,
                    borderTopRightRadius: 2,
                    mb: "-1px",
                    letterSpacing: "0.3px",
                }}
            >
                {title}
            </Heading>
            {actions && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, pb: 1 }}>
                    {actions}
                </Box>
            )}
        </Box>
    );
};

export default SectionTitle;
